import { Box, Modal, Typography, CircularProgress } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const DefaultLoader = ({ message }) => {
	const { t } = useTranslation();
	const defaultMessage = message || t('UI_TEXT.ORDER_PROCESSING_PLEASE_WAIT');

	return (
	<Modal
			open
			onClose={() => {}}
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<Box
				sx={{
					bgcolor: "background.paper",
					borderRadius: 2,
					boxShadow: 24,
					minWidth: { xs: 280, sm: 360 },
					maxWidth: "80vw",
					p: 4,
					textAlign: "center",
					outline: "none",
				}}
			>
				<Typography variant="h6" fontWeight="bold">
					{defaultMessage}
				</Typography>
				<CircularProgress sx={{ mt: 2 }} />
			</Box>
		</Modal>
	);
};

export default DefaultLoader;
